import React, { Fragment } from "react";
import { Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import PersonView from "./PersonView";
import DateRenderer from "./renderers/DateRenderer";
import { connect } from "react-redux";
import StudentController from "../api/StudentController";
import Loader from "react-loader";

interface SubjectsPopoverViewState
{
    data: SubjectParent;
    isLoading: boolean;
}

interface SubjectsPopoverViewProps
{
    settings?: any;
    class: ClassSubject;
    assignmentCount: any;
    termCode: any;
}

class SubjectsPopoverView extends React.Component<SubjectsPopoverViewProps, SubjectsPopoverViewState>
{
    studentController: StudentController;

    constructor(props: SubjectsPopoverViewProps)
    {
        super(props);

        this.studentController = new StudentController();

        this.state = {
            data: undefined,
            isLoading: true
        };
    }

    async componentDidMount()
    {
        let data = await this.studentController.getSubject(this.props.class.subjectCode, this.props.class.subjectNumber, this.props.termCode);
        console.log(data)
        const {
            lectures, assignments, recitations, exams
        } = data;


        if (data) {
            // If the subject is a Canvas Subject
            data = {
                "subject": {
                    "subject": this.props.class.subject,
                    "termCode": this.props.termCode,
                    "location": undefined,
                    "lectures": lectures,
                    "exams": exams,
                    "recitations": recitations,
                    "assignments": assignments
                }
            }
            
        } else {
            // If no subject was returned
            data = {
                "subject": {
                    "subject": undefined,
                    "termCode": undefined,
                    "location": undefined,
                    "lectures": [],
                    "exams": [],
                    "recitations": [],
                    "assignments": []
                }
            }
        }

        this.setState({
            data: data,
            isLoading: false,
        });

        this.handleAssignmentCount();
    }

    handleAssignmentCount = () =>
    {
        if (this.state.data.subject && this.state.data.subject.assignments.length > 0)
            this.props.assignmentCount(this.state.data.subject.assignments.length);
    }

    render(): React.ReactNode
    {
        if (this.state.isLoading)
            return <Container style={{ height: "100px", padding: "50px" }}>
                <Loader className={"spinner"} position={"relative"} scale={0.5} radius={15} corners={1} color={"#000"} opacity={0.25} rotate={0} direction={1} speed={1} trail={60} />
            </Container>;

        return <Fragment>
            {
                (this.state.data.subject)
                    ?
                    <Fragment>
                        <Row style={{ marginBottom: "20px" }}>
                      
                            <Col lg>
                                {
                                    (this.state.data.subject.subject)
                                        ?
                                        <h3>{this.state.data.subject.subject + " " + this.props.class.subjectTitle}</h3>
                                        :
                                        <p className="error-text">{"No Subject information availabl aaae"}</p>
                                }
                            </Col>
                            {/* <Col lg>
                                {
                                    (this.state.data.subject.location)
                                        ?
                                        <Fragment>
                                            <h3 id="content-desktop" className={"float-right"}><i className="far fa-map-marker"></i> {this.state.data.subject.location}</h3>
                                            <h3 id="content-mobile"><i className="far fa-map-marker"></i> {this.state.data.subject.location}</h3>
                                        </Fragment>
                                        :
                                        <p className="error-text">No Location information available</p>
                                }
                            </Col> */}
                        </Row>
                        <Row className={"text-center"}>
                            {
                                <Col className="right-border mb-2" lg={3}>
                                    <div style={{ whiteSpace: "nowrap" }}>
                                        <h4>Assignments <span style={{ opacity: "0.5" }} className="badge badge-secondary">{this.state.data.subject.assignments && this.state.data.subject.assignments.length}</span></h4>
                                    </div>
                                    {
                                        (this.state.data.subject.assignments && this.state.data.subject.assignments.length > 0)
                                            ?
                                            this.state.data.subject.assignments.map((assignment: Assignment, i: number) =>
                                            {
                                                return <div key={i}>
                                                    <Row>
                                                        <OverlayTrigger
                                                            placement={"top"}
                                                            overlay={
                                                                <Tooltip id={`tooltip-${i}`} role="tooltip">
                                                                    <strong>{assignment.name}</strong>.
                                                                    </Tooltip>
                                                            }
                                                        >
                                                            <Col className={"ellipsis"} sm={6}>
                                                                {assignment.name}
                                                            </Col>
                                                        </OverlayTrigger>{" "}
                                                        <Col sm={6}>
                                                            <DateRenderer value={assignment.due} type={"long"} />
                                                        </Col>
                                                    </Row>
                                                </div>;
                                            })
                                            :
                                            <div className="text-center" id='error'>
                                                <br />
                                                <p className="error-text">No Assignment data available</p>
                                            </div>
                                    }
                                </Col>
                            }
                            {
                                < Col className="right-border mb-2" lg={3} >
                                    <div style={{ whiteSpace: "nowrap" }}>
                                        <h4>Exams <span style={{ opacity: "0.5" }} className="badge badge-secondary">{this.state.data.subject.exams && this.state.data.subject.exams.length}</span></h4>
                                    </div>
                                    {
                                        (this.state.data.subject.exams && this.state.data.subject.exams.length > 0)
                                            ?
                                            this.state.data.subject.exams.map((exam: any, i: number) =>
                                            {
                                                return <div style={{ borderBottom: '1px solid #D9D9D9', paddingBottom: '1vw',display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}} key={i}>
                                                            <div>
                                                                <span><b>{exam.PERIOD_DATE}</b></span>
                                                            </div>
                                                            <div>
                                                                <span><i className="far fa-map-marker"></i> {exam.ROOM}</span>
                                                            </div>
                                                        </div>
                                            })
                                            :
                                            <div className="text-center" id='error'>
                                                <br />
                                                <p className="error-text">No Exams data available</p>
                                            </div>
                                    }
                                </Col>
                            }
                            {
                                <Col className="right-border mb-2" lg={3}>
                                    <div style={{ whiteSpace: "nowrap" }}>
                                        <h4>Lecture Times <span style={{ opacity: "0.5" }} className="badge badge-secondary">{this.state.data.subject.lectures && this.state.data.subject.lectures.length}</span></h4>
                                    </div>
                                    {
                                        (this.state.data.subject.lectures && this.state.data.subject.lectures.length > 0)
                                            ?
                                            <Fragment>
                                                {
                                                    this.state.data.subject.lectures.map((lectureTime: MeetLocation, i: number) =>
                                                    {
                                                        return lectureTime.schedules.map((time: string) => {
                                                        return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} key={i}>
                                                            <div>
                                                                <span>{time}</span>
                                                            </div>
                                                            <div>
                                                                <span><i className="far fa-map-marker"></i> {lectureTime.room}</span>
                                                            </div>
                                                        </div>
                                                        })
                                                        
                                                    })
                                                }
                                          
                                            </Fragment>
                                            :
                                            <div className="text-center" id='error'>
                                                <br />
                                                <p className="error-text">No Lecture Times data available</p>
                                            </div>
                                    }
                                </Col>
                            }
                            {
                                <Col lg={3}>
                                    <div style={{ whiteSpace: "nowrap" }}>
                                        <h4>Recitation Times <span style={{ opacity: "0.5" }} className="badge badge-secondary">{this.state.data.subject.recitations && this.state.data.subject.recitations.length}</span></h4>
                                    </div>
                                    {
                                        (this.state.data.subject.recitations && this.state.data.subject.recitations.length > 0)
                                            ?
                                            <Fragment>
                                                {
                                                    this.state.data.subject.recitations.map((recitationTime: MeetLocation, i: number) =>
                                                    {
                                                        return recitationTime.schedules.map((time: string) => {
                                                         return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} key={i}>
                                                            <div>
                                                                <span>{time}</span>
                                                            </div>
                                                            <div>
                                                                <span><i className="far fa-map-marker"></i> {recitationTime.room}</span>
                                                            </div>
                                                        </div>
                                                        })
                                                    })
                                                }
                                               
                                            </Fragment>
                                            :
                                            <div className="text-center" id='error'>
                                                <br />
                                                <p className="error-text">No Recitation Times data available</p>
                                            </div>
                                    }
                                </Col>
                            }
                        </Row>
                    </Fragment>
                    :
                    <div className="text-center" id='error'>
                        <br />
                        <p className="error-text">No Subject data aaa available</p>
                    </div>
            }
            {/*
                this.props.class.teachingAssistant != null
                    ?
                    <Row>
                        <Col><h6 className="grayText">Teaching Assistant</h6></Col>
                        <Col><PersonView data={this.state.data.teachingAssistant} /></Col>
                        <Col>{this.state.data.teachingAssistant.email}</Col>
                    </Row>
                    :
                    <div></div>
            */}
        </Fragment>;
    }
}

export default SubjectsPopoverView;